module.exports = __webpack_public_path__ + "img/skitime4.32edebd4.png";